import img_zozo from "../../../img/profile/work/zozo.png"
import img_teamlab from "../../../img/profile/work/teamlab.png"
import img_cookpad from "../../../img/profile/work/cookpad.png"
import img_plaid from "../../../img/profile/work/plaid.png"
import img_sou from "../../../img/profile/work/sou.png"
import img_gmo from "../../../img/profile/work/gmo.jpg"
import img_sansan from "../../../img/profile/work/sansan.png"
import img_ispec from "../../../img/profile/work/ispec.png"
import img_kw from "../../../img/profile/work/knowledge_work.png"
import img_copalette from "../../../img/profile/work/copalette.png"
import img_aivolt from "../../../img/profile/work/aivolt.png"
import img_upcare from "../../../img/profile/work/upcare.png"
import img_starup from "../../../img/profile/work/starup.png"
import img_prefab from "../../../img/profile/work/prefab.png"
import img_link from "../../../img/profile/work/link.png"
import img_bit_blend from "../../../img/profile/work/bit_blend.png"

const data = {
    "work":[
        {
            "date":"2023/4 - 現在 (2022/6 - 2023/3 アルバイト)",
            "img":img_zozo,
            "name":"株式会社ZOZO",
            "about":"正社員(バックエンドエンジニア) / Golangを用いて基盤APIやAPI Gatewayの開発運用に従事しています。"
        },
        {
            "date":"2025/3 - 現在",
            "img":img_bit_blend,
            "name":"合同会社 Bit Blend",
            "about":"業務委託(テックリード) / AI,ITスタートアップ企業の開発や技術検証、設計支援などに取り組んでいます。"
        },
        {
            "date":"2025/3 - 現在",
            "img":img_prefab,
            "name":"株式会社 Prefab",
            "about":"業務委託(技術顧問) / 建設業関係のAIアプリケーションの設計やコードレビューなどに取り組んでいます。"
        },
        {
            "date":"2024/9 - 2025/6(お休み中)",
            "img":img_starup,
            "name":"株式会社 STAR UP",
            "about":"業務委託(技術顧問) / 製造業関連の生成AIサービスの技術設計のレビューに取り組んでいます。"
        },
        {
            "date":"2024/8 - 2025/6(お休み中)",
            "img":img_upcare,
            "name":"株式会社 SPARQ",
            "about":"業務委託(SRE) / SREとしてインフラ基盤の構築や、アプリケーションの監視基盤を作っています。"
        },
        {
            "date":"2023/10 - 2025/8",
            "img":img_aivolt,
            "name":"株式会社AI VOLT",
            "about":"業務委託(テックリード) / 生成AIサービスのバックエンドの設計開発から、PM、保守・運用など幅広く取り組みました。"
        },
        {
            "date":"2023/5 - 2024/2",
            "img":img_copalette,
            "name":"株式会社CoPalette",
            "about":"共同創業者(取締役) / Golangを用いて人材管理のSaaSのAPI開発をしました。"
        },
        {
            "date":"2023/1 - 2023/3",
            "img":img_ispec,
            "name":"株式会社ispec",
            "about":"業務委託(バックエンドエンジニア) / Golangを用いたAPI開発をしました。"
        },
        {
            "date":"2023/3",
            "img":img_kw,
            "name":"株式会社ナレッジワーク",
            "about":"インターンシップ / Golangで「アーキテクチャの依存関係がルール違反してないか確認する静的解析ツール」を作成しました。"
        },
        {
            "date":"2022/8 - 2023/3",
            "img":img_plaid,
            "name":"株式会社プレイド",
            "about":"インターンシップ(バックエンドエンジニア) / Messageチームにて、API開発やSREの業務に取り組みました。"
        },
        {
            "date":"2022/9",
            "img":img_sansan,
            "name":"Sansan株式会社",
            "about":"インターンシップ / ハッカソン"
        },
        {
            "date":"2022/4 - 2022/5",
            "img":img_gmo,
            "name":"GMOインターネット",
            "about":"DevSecOpsThon / 物理サーバーの構築やチューニングなどに取り組みました。"
        },
        {
            "date":"2021/4 - 2022/7",
            "img":img_sou,
            "name":"株式会社ソウ",
            "about":"業務委託(フルスタックエンジニア) / さまざまなシステム設計、開発などを取り組みました。"
        },
        {
            "date":"2022/3",
            "img":img_teamlab,
            "name":"チームラボ株式会社",
            "about":"インターンシップ(フロントエンドエンジニア) / 機能拡張やテスト作成などの経験をしました。"
        },
        {
            "date":"2021/9",
            "img":img_cookpad,
            "name":"クックパッド株式会社",
            "about":"インターンシップ / RubyやGraphQLを用いた課題に取り組みました。"
        },
    ]
}

export default data;